import './social_content_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.InboxContentView extends Monitoring.Views.SocialContents.SocialContentView

  events: =>
    return _.extend({}, Monitoring.Views.SocialContents.SocialContentView.prototype.events, {
      "click .toggle" : "togglePhoto"
    })

  togglePhoto: (event) =>
    @$el.toggleClass('collapsed expanded', 0)

  render: ->
    super
    @$el.addClass("inbox #{@model.type()}")
    @$el.addClass('clipping-news') if @model.isClippingNews?()
    this
